import React from 'react';
import SavedTicketIcon from '@/icons/SavedTicketIcon';
import { isTicketSaved } from '@/mytickets/utils';

export default function TicketStateIcon({ ticket }) {
    const icon = ticket.displayStatus;
    if (isTicketSaved(ticket)) {
        return (
            <div className="ticket-state-icon-placeholder">
                <SavedTicketIcon />
            </div>
        );
    }
    return <div className={`ticket-state ticket-state-${icon}`} />;
}
